import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60ac91a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle-1" }
const _hoisted_2 = { class: "log" }
const _hoisted_3 = { class: "subtitle-1 mt-3" }

import SelectItems from "@/utils/SelectItems";
import {computed, Reactive, reactive, ref} from "vue";
import {Guild} from "@/types/Guild";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {GuildSettings} from "@/types/GuildSettings";
import config from "@/config.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildLogsView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let channels = SelectItems.channels(guild.value!.channels!, false)
let ignoredChannels = SelectItems.channels(guild.value!.channels!, false, false)
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let valid = ref(true);
let submitting = ref(false);

const categories = {
  messages: ['messageDelete', 'messageEdit', 'messageDeleteBulk'],
  roles: ['roleCreate', 'roleEdit', 'roleDelete'],
  moderation: ['moderationWarn', 'moderationMute', 'moderationKick', 'moderationBan',
    'moderationUnmute', 'moderationUnban']
}
const icons = ['speaker_notes', 'assignment', 'security']

for (let log of Object.values(categories).flat(1)) {
  if (!settings.logs.list[log]?.enabled || !channels.find(ch => ch.value === settings.logs.list[log]?.channel))
    settings.logs.list[log] = {enabled: false, channel: null}
}

async function submit() {
  submitting.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/logs`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify(settings.logs)
      })
  if(response.ok) emit('submitted', 'success', settings)
  else emit('submitted', 'error')
  submitting.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _unref(valid),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('GuildLogs.subtitles.logs')), 1),
        _createVNode(_component_v_expansion_panels, {
          class: "logs",
          variant: "accordion"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(categories), (category, i) => {
              return (_openBlock(), _createBlock(_component_v_expansion_panel, { "bg-color": "block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, {
                    class: "category",
                    ripple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "category-icon" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(icons[i]), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`GuildLogs.categories.${category}`)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories[category], (log) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t(`GuildLogs.logs.${log}`)), 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_select, {
                                modelValue: _unref(settings).logs.list[log].channel,
                                "onUpdate:modelValue": ($event: any) => ((_unref(settings).logs.list[log].channel) = $event),
                                items: _unref(channels),
                                color: "primary",
                                "hide-details": "",
                                disabled: !_unref(settings).logs.list[log].enabled,
                                label: _ctx.$t(`GuildLogs.subtitles.channel`),
                                class: "channel-select mr-3"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "label"]),
                              _createVNode(_component_v_switch, {
                                modelValue: _unref(settings).logs.list[log].enabled,
                                "onUpdate:modelValue": ($event: any) => ((_unref(settings).logs.list[log].enabled) = $event),
                                "hide-details": "",
                                color: "primary",
                                class: "switch"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]),
                          (categories[category].indexOf(log) < categories[category].length - 1)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('GuildLogs.subtitles.ignoredChannels')), 1),
        _createVNode(_component_v_select, {
          modelValue: _unref(settings).logs.ignore.channels,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).logs.ignore.channels) = $event)),
          label: _ctx.$t('GuildLogs.subtitles.channels'),
          hint: _ctx.$t('GuildLogs.subtitles.ignoredChannelsHint'),
          color: "primary",
          "persistent-hint": "",
          multiple: "",
          chips: "",
          "closable-chips": "",
          items: _unref(ignoredChannels),
          class: "channels-select mt-1 mb-2"
        }, null, 8, ["modelValue", "label", "hint", "items"]),
        _createVNode(_component_v_btn, {
          class: "submit",
          disabled: _unref(valid) === false,
          loading: _unref(submitting),
          size: "large",
          color: "secondary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "save-icon" }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildLogs.submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})